import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_ENDPOINTS } from "../config";
import heroImage from "../assets/tog.jpg"; // Add a banner image
import img1 from "../assets/aa.jpg";
import img11 from "../assets/1.JPG";
import img22 from "../assets/2.JPG";
import img33 from "../assets/3.JPG";
import img44 from "../assets/4.jpg";
import img55 from "../assets/5.jpg";
import img77 from "../assets/7.jpg";
import img88 from "../assets/8.jpg";
import img9 from "../assets/9.jpg";
import img10 from "../assets/10.jpg";
import img111 from "../assets/sg.jpeg";
import img12 from "../assets/12.jpg";
import img13 from "../assets/13.jpg";
import img14 from "../assets/14.jpg";
import img15 from "../assets/15.jpg";
import img16 from "../assets/16.jpg";
import img17 from "../assets/17.jpg";
import img18 from "../assets/18.jpg";
import img19 from "../assets/19.jpg";
import img20 from "../assets/20.jpg";
import img21 from "../assets/21.jpg";
import img222 from "../assets/22.jpg";
import img23 from "../assets/23.jpg";
import img24 from "../assets/24.jpg";
import img25 from "../assets/25.jpg";
import img26 from "../assets/26.jpg";
import img27 from "../assets/27.jpg";
import img28 from "../assets/28.jpg";
import img29 from "../assets/29.jpg";
import img30 from "../assets/30.jpg";
import img31 from "../assets/31.jpg";
import img32 from "../assets/32.jpg";
import img333 from "../assets/33.jpg";
import img34 from "../assets/34.jpg";
import img35 from "../assets/35.jpg";
import img36 from "../assets/36.jpg";
import img37 from "../assets/37.jpg";
import img38 from "../assets/38.jpg";
import img39 from "../assets/39.jpg";
import img40 from "../assets/40.jpg";
import img41 from "../assets/41.jpg";
import img42 from "../assets/42.jpg";
import img43 from "../assets/43.jpg";
import img444 from "../assets/44.jpg";
import img45 from "../assets/p.jpeg";
import img46 from "../assets/46.jpg";
import img47 from "../assets/47.jpg";
import img48 from "../assets/48.jpg";
import img49 from "../assets/49.jpg";
import img50 from "../assets/50.jpg";
import img51 from "../assets/51.jpg";
import img52 from "../assets/52.jpg";
import img53 from "../assets/53.jpg";
import img54 from "../assets/54.jpg";
import img555 from "../assets/55.jpg";
import img66 from "../assets/6.jpg";

const backgroundImages = [heroImage, img10, img111, img12, img18];

const HomePage = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [isSubscribing, setIsSubscribing] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    
    if (!email) {
      alert("Please enter your email address");
      return;
    }

    setIsSubscribing(true);

    try {
      const response = await fetch(API_ENDPOINTS.SUBSCRIBE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setSubscribed(true);
        setEmail("");
        setTimeout(() => setSubscribed(false), 5000);
      } else {
        alert(data.message || "Subscription failed. You may already be subscribed.");
      }
    } catch (error) {
      console.error("Subscription Error:", error);
      alert("Failed to subscribe. Please try again later.");
    } finally {
      setIsSubscribing(false);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === backgroundImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div style={styles.container}>
      {/* Enhanced Hero Section */}
      <section
        style={{
          ...styles.hero,
          backgroundImage: `url(${backgroundImages[currentImageIndex]})`,
        }}
        className="hero"
      >
        <div style={styles.heroOverlay} className="heroOverlay">
          <h1 style={styles.heroTitle}>
            Welcome to Lesotho Nursing and Midwifery Organization
          </h1>
          <p style={styles.heroText}>
            Empowering healthcare professionals through education, advocacy, and community support. 
            Join us in shaping the future of healthcare in Lesotho.
          </p>
          <div style={styles.ctaContainer}>
            <Link to="/about" style={styles.ctaButton}>
              Learn More About Us
            </Link>
            <Link to="/membership" style={styles.ctaSecondary}>
              Join Today
            </Link>
          </div>
        </div>
      </section>

      {/* Enhanced Welcome Section */}
      <section style={styles.welcome} className="welcome">
        <h2>Transforming Healthcare in Lesotho</h2>
        <p>
          The Lesotho Nursing and Midwifery Organization is the leading professional 
          body dedicated to advancing nursing and midwifery practice through education, 
          advocacy, and community engagement.
        </p>
        
        {/* Stats Section */}
        <div style={styles.stats}>
          <div style={styles.statItem}>
            <div style={styles.statNumber}>2,000+</div>
            <div style={styles.statLabel}>Members</div>
          </div>
          <div style={styles.statItem}>
            <div style={styles.statNumber}>18</div>
            <div style={styles.statLabel}>Branches</div>
          </div>
          <div style={styles.statItem}>
            <div style={styles.statNumber}>60+</div>
            <div style={styles.statLabel}>Years of Service</div>
          </div>
          <div style={styles.statItem}>
            <div style={styles.statNumber}>50+</div>
            <div style={styles.statLabel}>Annual Events</div>
          </div>
        </div>
      </section>

      {/* Enhanced Gallery Section */}
      <section style={styles.gallery} className="gallery">
        <h2>Our Impact in Action</h2>
        <p style={styles.gallerySubtitle}>
          Witness the difference we make in communities across Lesotho
        </p>
        <div style={styles.galleryGrid}>
          {[img1, img11, img111, img44, img12, img13, img14, img15, img16, img17, img18, img19].map((img, index) => (
            <img 
              key={index}
              src={img} 
              alt={`LENMO Activity ${index + 1}`}
              style={styles.galleryImage}
              loading="lazy"
              className="galleryImage"
            />
          ))}
        </div>
      </section>
      
      {/* Newsletter Subscription Section */}
      <section style={styles.newsletter}>
        <h2 style={styles.newsletterTitle}>Subscribe to Our Newsletter</h2>
        <p style={styles.newsletterText}>
          Stay updated with LENMO news, events, opportunities, and professional updates.
        </p>

        {subscribed ? (
          <p style={styles.successMessage}>
            ✅ Thank you for subscribing to our newsletter!
          </p>
        ) : (
          <form style={styles.newsletterForm} onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={styles.newsletterInput}
              disabled={isSubscribing}
            />
            <button 
              type="submit" 
              style={{
                ...styles.newsletterButton,
                ...(isSubscribing ? styles.buttonDisabled : {})
              }}
              disabled={isSubscribing}
            >
              {isSubscribing ? "Subscribing..." : "Subscribe"}
            </button>
          </form>
        )}
      </section>

      {/* Enhanced Call to Action */}
      <section style={styles.explore} className="explore">
        <h2>Ready to Make a Difference?</h2>
        <p>
          Join thousands of healthcare professionals who are transforming patient care 
          and advancing the nursing profession in Lesotho.
        </p>
        <div style={styles.ctaContainer}>
          <Link to="/membership" style={styles.exploreButton}>
            Become a Member Today
          </Link>
          <Link to="/events" style={styles.ctaSecondaryLight}>
            View Upcoming Events
          </Link>
        </div>
      </section>
    </div>
  );
};

// Updated styles with bright colors and mobile gallery
const styles = {
  container: {
    fontFamily: "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    color: "#001f54",
  },
  hero: {
    transition: "background-image 1.2s cubic-bezier(0.4, 0, 0.2, 1)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  heroOverlay: {
    backgroundColor: "rgba(0, 31, 84, 0.85)",
    padding: "3rem",
    borderRadius: "20px",
    color: "#fff",
    textAlign: "center",
    maxWidth: "800px",
    backdropFilter: "blur(10px)",
  },
  heroTitle: {
    fontSize: "clamp(2.8rem, 6vw, 4.0rem)",
    marginBottom: "1.5rem",
    fontWeight: "600",
    lineHeight: "1.0",
    background: "linear-gradient(135deg, #FFFFFF 0%, #FFD700 30%, #FF8E53 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },
  heroText: {
    fontSize: "clamp(1.3rem, 3vw, 1.5rem)",
    marginBottom: "2.5rem",
    lineHeight: "1.6",
    opacity: "0.95",
    textShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
  },
  ctaContainer: {
    display: "flex",
    gap: "1.5rem",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  ctaButton: {
    background: "linear-gradient(135deg, #FF6B35 0%, #FF8E53 100%)",
    color: "#fff",
    padding: "1.3rem 2.8rem",
    borderRadius: "30px",
    fontWeight: "800",
    textDecoration: "none",
    transition: "all 0.4s ease",
    boxShadow: "0 8px 25px rgba(255, 107, 53, 0.3)",
    fontSize: "1.2rem",
  },
  ctaSecondary: {
    backgroundColor: "transparent",
    color: "#fff",
    padding: "1.3rem 2.8rem",
    borderRadius: "30px",
    fontWeight: "700",
    textDecoration: "none",
    border: "3px solid #fff",
    transition: "all 0.3s ease",
    fontSize: "1.2rem",
  },
  welcome: {
    padding: "6rem 2rem",
    textAlign: "center",
    backgroundColor: "#f8f9fa",
  },
  stats: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "2rem",
    maxWidth: "1000px",
    margin: "4rem auto 0",
    padding: "2rem",
  },
  statItem: {
    textAlign: "center",
    padding: "2.5rem 2rem",
    backgroundColor: "#fff",
    borderRadius: "20px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    transition: "transform 0.3s ease",
  },
  statNumber: {
    fontSize: "3rem",
    fontWeight: "800",
    color: "#0056b3",
    marginBottom: "0.5rem",
  },
  statLabel: {
    fontSize: "1.2rem",
    color: "#4a5568",
    fontWeight: "600",
  },
  gallery: {
    padding: "6rem 2rem",
    backgroundColor: "#fff",
    textAlign: "center",
  },
  gallerySubtitle: {
    fontSize: "1.3rem",
    color: "#4a5568",
    marginBottom: "3rem",
    maxWidth: "600px",
    margin: "0 auto 3rem",
  },
  galleryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "2rem",
    maxWidth: "1400px",
    margin: "0 auto",
  },
  galleryImage: {
    width: "100%",
    borderRadius: "15px",
    height: "280px",
    objectFit: "cover",
    transition: "all 0.4s ease",
    boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
    cursor: "pointer",
  },
  explore: {
    padding: "6rem 2rem",
    textAlign: "center",
    background: "linear-gradient(135deg, #0056b3 0%, #4d88ff 100%)",
    color: "#fff",
  },
  exploreButton: {
    background: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)",
    color: "#0056b3",
    padding: "1.3rem 2.8rem",
    borderRadius: "30px",
    fontWeight: "800",
    textDecoration: "none",
    transition: "all 0.4s ease",
    boxShadow: "0 8px 25px rgba(255, 215, 0, 0.3)",
    fontSize: "1.2rem",
  },
  ctaSecondaryLight: {
    backgroundColor: "transparent",
    color: "#fff",
    padding: "1.3rem 2.8rem",
    borderRadius: "30px",
    fontWeight: "700",
    textDecoration: "none",
    border: "3px solid #fff",
    transition: "all 0.3s ease",
    fontSize: "1.2rem",
  },
  newsletter: {
    padding: "5rem 2rem",
    backgroundColor: "#f1f5f9",
    textAlign: "center",
  },
  newsletterTitle: {
    fontSize: "2.5rem",
    fontWeight: "800",
    marginBottom: "1rem",
    color: "#001f54",
  },
  newsletterText: {
    fontSize: "1.2rem",
    color: "#4a5568",
    marginBottom: "2.5rem",
    maxWidth: "600px",
    marginInline: "auto",
  },
  newsletterForm: {
    display: "flex",
    justifyContent: "center",
    gap: "1rem",
    flexWrap: "wrap",
  },
  newsletterInput: {
    padding: "1rem 1.5rem",
    borderRadius: "30px",
    border: "2px solid #0056b3",
    minWidth: "280px",
    fontSize: "1rem",
    outline: "none",
    transition: "all 0.3s ease",
  },
  newsletterButton: {
    padding: "1rem 2.5rem",
    borderRadius: "30px",
    border: "none",
    background: "linear-gradient(135deg, #0056b3 0%, #4d88ff 100%)",
    color: "#fff",
    fontWeight: "700",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  buttonDisabled: {
    opacity: 0.7,
    cursor: "not-allowed",
  },
  successMessage: {
    fontSize: "1.2rem",
    fontWeight: "600",
    color: "#2f855a",
    padding: "1rem",
    backgroundColor: "#e6f4ea",
    borderRadius: "8px",
    display: "inline-block",
  },
};

export default HomePage;